import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "link-text" }

import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { informationLinkKey, informationRowKey } from '../i18n-keys';


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationSection',
  setup(__props) {

const { t } = useI18n();

function resolveValue(row: (typeof appData.information)[number]): string {
  if (row.value !== undefined) return row.value;
  if (!row.valueKey) return '';
  return t(`appStore.${row.valueKey}`);
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('appStore.informationTitle')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).information, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: row.labelKey,
        class: "info-row"
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)(_unref(informationRowKey)(row.labelKey))), 1),
        (row.labelKey == 'provider')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["value", { muted: row.expandable }])
            }, [
              _createTextVNode(_toDisplayString(_unref(t)('donwload.appName')) + " ", 1),
              (row.expandable)
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "arrow-down",
                    size: "14",
                    color: "#9ca3af"
                  }))
                : _createCommentVNode("", true)
            ], 2))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["value", { muted: row.expandable }])
            }, [
              _createTextVNode(_toDisplayString(resolveValue(row)) + " ", 1),
              (row.expandable)
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    name: "arrow-down",
                    size: "14",
                    color: "#9ca3af"
                  }))
                : _createCommentVNode("", true)
            ], 2))
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appData).externalLinks, (link) => {
      return (_openBlock(), _createElementBlock("div", {
        key: link.i18nKey,
        class: "link-row"
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(_unref(informationLinkKey)(link.i18nKey))), 1),
        _createVNode(_component_van_icon, {
          name: link.icon,
          size: "16",
          color: "#4b5563"
        }, null, 8, ["name"])
      ]))
    }), 128))
  ]))
}
}

})